export default __webpack_public_path__ + "static/media/area.08064601.png";